import { ProductImageUploadTranslations } from "./product-image-upload-pt-br";

export const PRODUCT_IMAGE_UPLOAD_ES_MX: ProductImageUploadTranslations = {
	addImage: "Añadir imagen",
	removeImage: "Eliminar imagen cargada",
	formatInfo: "JPG o PNG",
	ariaLabel: {
		uploadedImage: "Imagen del producto cargada",
	},
};
